module.exports = __webpack_public_path__ + "img/app.b17a6986.png";